import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCalendarMonth = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#5C78C7"
        d="M4.756 17.583q-.563 0-.95-.395a1.3 1.3 0 0 1-.39-.944V5.756q0-.548.39-.943.387-.396.95-.396h1.821V2.878a.543.543 0 0 1 .553-.557.55.55 0 0 1 .562.557v1.539h4.648V2.862a.527.527 0 0 1 .537-.541q.229 0 .387.155a.52.52 0 0 1 .159.386v1.555h1.82q.564 0 .952.396a1.3 1.3 0 0 1 .388.943v10.488q0 .548-.388.944-.39.395-.951.395zm0-1.083h10.488a.25.25 0 0 0 .176-.08.25.25 0 0 0 .08-.176V9.256h-11v6.988q0 .096.08.176t.176.08M4.5 8.173h11V5.756a.25.25 0 0 0-.08-.176.25.25 0 0 0-.176-.08H4.756a.25.25 0 0 0-.176.08.25.25 0 0 0-.08.176zm5.504 3.891a.64.64 0 0 1-.463-.19.62.62 0 0 1-.195-.46.64.64 0 0 1 .19-.463.62.62 0 0 1 .46-.195.64.64 0 0 1 .463.19q.195.191.195.46a.64.64 0 0 1-.19.463.62.62 0 0 1-.46.195m-3.25 0a.64.64 0 0 1-.463-.19.62.62 0 0 1-.195-.46.64.64 0 0 1 .19-.463.62.62 0 0 1 .46-.195.64.64 0 0 1 .463.19q.195.191.195.46a.64.64 0 0 1-.19.463.62.62 0 0 1-.46.195m6.5 0a.64.64 0 0 1-.463-.19.62.62 0 0 1-.195-.46.64.64 0 0 1 .19-.463.62.62 0 0 1 .46-.195.64.64 0 0 1 .463.19q.195.191.195.46a.64.64 0 0 1-.19.463.62.62 0 0 1-.46.195M10.004 15a.64.64 0 0 1-.463-.19.62.62 0 0 1-.195-.46.64.64 0 0 1 .19-.463.62.62 0 0 1 .46-.195.64.64 0 0 1 .463.19q.195.19.195.46a.64.64 0 0 1-.19.463.62.62 0 0 1-.46.195m-3.25 0a.64.64 0 0 1-.463-.19.62.62 0 0 1-.195-.46.64.64 0 0 1 .19-.463.62.62 0 0 1 .46-.195.64.64 0 0 1 .463.19q.195.19.195.46a.64.64 0 0 1-.19.463.62.62 0 0 1-.46.195m6.5 0a.64.64 0 0 1-.463-.19.62.62 0 0 1-.195-.46.64.64 0 0 1 .19-.463.62.62 0 0 1 .46-.195.64.64 0 0 1 .463.19q.195.19.195.46a.64.64 0 0 1-.19.463.62.62 0 0 1-.46.195"
      />
    </g>
  </svg>
);
export default SvgCalendarMonth;
